var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTeamLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.844c1.103 0 2-.873 2-1.948 0-1.074-.897-1.948-2-1.948s-2 .874-2 1.948c0 1.075.897 1.948 2 1.948zm14 0c1.103 0 2-.873 2-1.948 0-1.074-.897-1.948-2-1.948s-2 .874-2 1.948c0 1.075.897 1.948 2 1.948zm1 .974h-2c-.55 0-1.047.216-1.41.566 1.26.673 2.154 1.888 2.348 3.33H21c.553 0 1-.435 1-.974v-.974c0-1.074-.897-1.948-2-1.948zm-12.59.566A2.021 2.021 0 0 0 6 11.818H4c-1.103 0-2 .874-2 1.948v.974c0 .539.447.974 1 .974h2.06c.196-1.442 1.09-2.657 2.35-3.33zM9.86 12.792a5.041 5.041 0 0 0 2.14.487 5.03 5.03 0 0 0 2.14-.487h.26c1.987 0 3.6 1.57 3.6 3.507v.876c0 .807-.672 1.461-1.5 1.461h-9c-.828 0-1.5-.654-1.5-1.46v-.877c0-1.936 1.612-3.507 3.6-3.507zM12 5c1.934 0 3.5 1.525 3.5 3.41 0 1.883-1.566 3.408-3.5 3.408S8.5 10.293 8.5 8.41 10.066 5 12 5z",
    fill: "#8F9BB3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeamLinear);
export default __webpack_public_path__ + "static/media/icon-team-linear.e92a1b02.svg";
export { ForwardRef as ReactComponent };